import {cn} from "@bem-react/classname";
import {IClassNameProps} from "@bem-react/core";
import React, {CSSProperties} from "react";
import './Svg.css';

export const cnSvg = cn('Svg');

export interface ISvgProps extends IClassNameProps {
    icon: string;
    label?: string;
    style?: CSSProperties;
    onClick?: (event: any) => void;
}

export const Svg: React.FC<ISvgProps> = ({className, icon, label, style, onClick}) => {
    return (
        <svg
            className={cnSvg({}, [className])}
            aria-label={label}
            style={style}
            onClick={onClick}
        >
            <use xlinkHref={`#${icon}`}/>
        </svg>
    );
};